/**
 * Design tokens for the Tandem console. The app's MUI theme is a blue variant and
 * does not carry the WorkNest purple, so — like Home.tsx — the console uses these
 * brand values directly.
 */

export const T = {
    font: "'Nunito', 'Segoe UI', system-ui, sans-serif",

    // Brand / ink
    ink: "#12054d", // sidebar + primary dark
    ink2: "#150850", // body text
    indigoDeep: "#1d1060", // engine status card
    indigoBorder: "#2c1d75",

    // Purple accents
    purple: "#7a5cf0",
    purpleDeep: "#5636c9",
    purpleTint: "#F2EEFF",

    // Timesheet entries logged in the Tools app
    logged: "#2F7FC1",

    // Surfaces
    bg: "#EDF0F7",
    card: "#FFFFFF",
    border: "#DEE2EF",
    borderSoft: "#E7EAF4",
    rowTint: "#FAFBFE",

    // Text
    muted: "#5F6379",
    muted2: "#9AA1B6",

    // Status
    green: "#0F7B5F",
    greenTint: "#EDF7F2",
    amber: "#B45309",
    amberTint: "#FDF3E3",
    amberBorder: "#EAD9B0",
    red: "#B4231F",
    redPill: "#C2361B",

    // Sidebar
    sidebarText: "#E9E5FB",
    sidebarMuted: "#a89ddd",
    sidebarHover: "#241668",
} as const;
